import { toMoney } from "../../Components/Functions";
import { UPDATE } from "./types";

const INITIAL_STATE = {
	alert: {
		type: "danger",
		// body: `Your account is at risk of suspension on <b>Sunday, Nov 21</b> due to an overdue balance of <b>${toMoney(4650)}</b>. Click <a class="action-link">here</a> to make payment.`
		// body: `You have a new appointment request from <b>Malawi Andrew</b> for Sun, Dec 23rd, 2021. Click here to Accept or Decline.`
	}
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:
			return {
				...state,
				...action
			};

		default:
			return state;
	}
};


